module.exports = __webpack_public_path__ + "static/media/spain.d553cd69.svg";